import { css } from "@emotion/react";
import { getCustomResponsiveStyles } from "@/utils";
import { Colors, Shadows, Typography } from "@zapier/design-system";

export const styles = {
  recommendedPlanOverviewWrapper: getCustomResponsiveStyles({
    mobile: css({
      border: `2px solid ${Colors.earth}`,
      marginTop: 0,
      paddingTop: "calc(20px + 28px)",
    }),

    tablet: css({
      marginBottom: "-30px",
      top: "-30px",
    }),
  }),

  tableFeatureRoot: css`
    height: 100%;
  `,

  secondaryCtaWrapper: getCustomResponsiveStyles({
    mobile: css`
      display: flex;
      align-items: flex-end;
      justify-content: center;

      &:not(:empty) {
        margin-top: 12px;
      }
    `,
  }),
  planOverview: getCustomResponsiveStyles({
    tablet: css`
      display: grid;
      grid-template-rows: 40px minmax(100px, max-content) 90px 70px minmax(
          35px,
          max-content
        );
      height: 100%;
      margin: 0 auto;
    `,
  }),
  primaryCtaWrapper: getCustomResponsiveStyles({
    tablet: css`
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    `,
  }),
  priceDetails: getCustomResponsiveStyles({
    mobile: css`
      margin: 15px 0 18px 0;
    `,
    tablet: css`
      margin: 0;
    `,
  }),
  planOverviewWrapper: getCustomResponsiveStyles({
    mobile: css({
      ":hover": {
        boxShadow: Shadows.elevation6,
      },
      background: Colors.neutral100,
      borderRadius: 10,
      border: `1px solid ${Colors.neutral400}`,
      display: "block",
      padding: "20px",
      position: "relative",
      transition: "all 0.5s ease",
      flexGrow: 1,
    }),
  }),

  featuresWrapper: getCustomResponsiveStyles({
    mobile: css`
      margin-top: 15px;
      display: flex;
      flex-direction: column;
      gap: 8px;
    `,
    tablet: css`
      margin-top: 12px;
      gap: 12px;
    `,
  }),

  featureTitle: getCustomResponsiveStyles({
    mobile: css({
      ...Typography.paragraph3Bold,
    }),
    desktop: css({ ...Typography.smallPrint1Bold }),
  }),

  root: getCustomResponsiveStyles({
    tablet: css({
      display: "flex",
    }),
    mobile: css({
      display: "block",
      flexDirection: "column",
      width: "100%",
      position: "relative",
      zIndex: 1,
    }),
  }),

  tag: css({
    width: "fit-content",
    position: "absolute",
    top: "-10px",
    left: "20px",
    zIndex: 2,
  }),

  footerLinkWrapper: getCustomResponsiveStyles({
    mobile: css({
      ...Typography.smallPrint1,
      padding: "10px 0 5px 0",
      textUnderlineOffset: "3px",
      fontWeight: 500,
    }),
    desktop: css({ padding: "20px 0 10px 0" }),
  }),
};
